<template>
    <div class="pa-5">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Merge into" | t }}</v-col>
            <v-col cols="6">
                <v-autocomplete
                    v-model="shop"
                    :items="mergeShops"
                    :label="'Shops' | t"
                    :loading="isLoading"
                    :value="shop"
                    class="pa-0 t-spacing"
                    color="bal-red"
                    hide-no-data
                    hide-details
                    hide-selected
                    item-text="name"
                    item-value="id"
                    outlined
                    autofocus
                    dense
                />
            </v-col>
            <v-col cols="2" class="ml-4">
                <v-btn @click="submitMerge" dark color="bal-red">
                    <v-icon>merge_type</v-icon>
                    {{ "Merge" | t }}
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

export default {
    name: "merge-shops-edit-tab",
    data() {
        return {
            shop: null,
            shops: [],
            isLoading: false
        };
    },
    created() {
        this.getMergeShops();
    },
    computed: {
        ...mapState("ShopsAdminStore", ["mergeShops", "activeShop", "tableOptions", "searchShopString"])
    },
    methods: {
        ...mapMutations("ShopsAdminStore", ["setRequestSuccess", "setRequestError", "setErrorMessage"]),
        ...mapActions("ShopsAdminStore", ["getMergeShops", "sendMergeShops", "getShopsList"]),
        async submitMerge() {
            if (this.shop && this.shop !== this.activeShop.id) {
                if (confirm(this.t("Are you sure you want to merge shops?"))) {
                    let data = {
                        mergeFrom: this.activeShop.id,
                        mergeTo: this.shop
                    };
                    const result = await this.sendMergeShops(data);
                    console.log(result);
                    if (result && result.success === 1) {
                        await this.$router.push({
                            name: "shops-admin-list"
                        });
                        await this.getShopsList({
                            options: this.tableOptions,
                            search: this.searchShopString
                        });
                        this.setRequestSuccess(true);
                    } else {
                        this.setErrorMessage("Failed");
                        this.setRequestError(true);
                    }
                }
            } else {
                this.setErrorMessage("Failed");
                this.setRequestError(true);
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: grey;
}
</style>
